import { ReactNode } from "react";
import { ModalComponent } from "..";

export const SuccessModal = ({
  message,
  isModalOpen,
  onModalClose = () => {},
  subText,
  callback = () => {},
  children,
}: {
  message?: ReactNode;
  isModalOpen: boolean;
  onModalClose?: () => void;
  subText?: ReactNode;
  callback?: () => void;
  children?: ReactNode;
}) => {
  return (
    <ModalComponent
      isModalOpen={isModalOpen}
      onModalClose={() => {
        callback();
        onModalClose();
      }}
      title=""
      subTitle=""
      childrenClassName="!pb-10"
      modalClassName="!min-h-fit"
      hasButtons={false}
      proceedButtonText=""
      onProceedClick={() => {}}
      hasCancelButton={false}
      onCancelClick={() => {}}
      isLoading={false}
      isProceedDisabled={false}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img
          src={"/assets/images/success.svg"}
          alt="success"
          className="w-full max-w-[224px] mt-4"
        />

        <div className="mt-[16px] w-full text-center text-lg font-bold">
          {message}
        </div>

        {subText && (
          <div className="mt-1 text-sm text-pry-dark-green-300/80 w-full text-center">
            {subText}
          </div>
        )}

        {children}
      </div>
    </ModalComponent>
  );
};
